export default __webpack_public_path__ + "static/media/sanjivani-tea.4706041a.jpg";